import { doc, serverTimestamp, setDoc } from 'firebase/firestore'
import {
  buildBookingFactDocument,
  type BookingFactCreateInput,
  type ConsultationId,
  type CustomerId,
} from '@gh/common/models'
import { firestore } from '@/firebase'
import createLogger from '@/utils/logger'

const logger = createLogger('bookingFacts')

export async function writeBookingFact(args: {
  consultationId: ConsultationId
  customerId: CustomerId
  fact: Omit<BookingFactCreateInput, 'id' | 'consultationId' | 'customerId'>
}): Promise<void> {
  try {
    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `fact-${Date.now()}-${Math.random().toString(16).slice(2)}`
    const document = buildBookingFactDocument({
      ...args.fact,
      id,
      consultationId: args.consultationId,
      customerId: args.customerId,
    })
    await setDoc(doc(firestore, 'consultations', args.consultationId, 'bookingFacts', id), {
      ...document,
      occurredAt: serverTimestamp(),
    })
  } catch (error) {
    logger.warn('Clinical booking fact write failed', {
      consultationId: args.consultationId,
      factType: args.fact.factType,
      error,
    })
  }
}
